/* eslint-disable max-len */
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DisplayService } from '../../services/display/display.service';
import { CommsService } from '../../services/comms/comms.service';
import { ConfigService } from '../../services/config/config.service';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { NoteService } from '../../services/note/note.service';
import { DataService } from '../../services/data/data.service';

@Component({
	selector: 'pcm-data-page-supplier-invoice',
	templateUrl: './data-page-supplier-invoice.component.html',
	styleUrls: ['./data-page-supplier-invoice.component.scss']
})
export class DataPageSupplierInvoiceComponent implements OnInit {

	title = 'Supplier Invoice Details';
	poNumber;
	invoiceNumber;
	supplierId;
	supInvoiceDetails: any = {};
	dataConfig;
	dataObj = 'lineitem';
	showUpdateInvoiceModal = false;
	canUpdate = false;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public configService: ConfigService,
		private commsService: CommsService,
		private noteService: NoteService,
		private displayService: DisplayService,
		private invoiceService: InvoiceService
	) { }

	ngOnInit() {
		this.dataConfig = this.configService.getDataObj(this.invoiceService.supDataObj);

		const self = this;
		self.route.params.subscribe(params => {
			self.poNumber = params['poNumber'];
			self.supplierId = params['supplierId'];
			self.invoiceNumber = params['invoiceNumber'];

			this.loadSupplierInvoice(params['poNumber'], params['supplierId'], params['invoiceNumber']);
		});
	}

	loadSupplierInvoice(poNumber, supplierId, invoiceNumber) {
		this.displayService.startLoading();
		const data = {
			ponumber: poNumber,
			supplierid: supplierId,
			invoicenumber: invoiceNumber
		};

		this.commsService.getSupplierInvoiceDetails(data).subscribe((res) => {
			console.log('GET INVOICE RECONCILIATION', res);
			this.supInvoiceDetails = this.commsService.getSuccessData(res);
			const cleartoinvoice = this.supInvoiceDetails[this.configService.invoiceChaincodeProp];
			if (this.invoiceService.getActiveTab(this.invoiceService.tabsData.supListTabs)['prop'] === 'pending'
			|| cleartoinvoice && cleartoinvoice.toLowerCase() === 'pending') {
				this.canUpdate = true;
			}
			this.invoiceService.parseItems(this.supInvoiceDetails[this.configService.invoiceItemsProp], this.supInvoiceDetails[this.configService.countryCodeProp]);
			this.displayService.endLoading();
		}, (err) => {
			this.displayService.endLoading();
			this.commsService.handleAPIError('GET INNVOICE RECONCILIATION', err);
		});
	}

	updateBillingPeriods() {
		if (this.configService.persona === this.configService.personaProps['sam']
			|| this.configService.persona === this.configService.personaProps['fa']) {
			console.log('INVOICE TABLE CLICK: ', event);
			this.showUpdateInvoiceModal = true;
		}
	}

	closeUpdateInvoiceModal() {
		this.showUpdateInvoiceModal = false;
	}

	updateInvoice(event) {
		const data =  {
			invoicenumber: this.invoiceNumber,
			ponumber: this.poNumber,
			supplierid: this.supplierId,
			billingstart: event.data.billingstart,
			billingend: event.data.billingend
		};
		this.closeUpdateInvoiceModal();
		const self = this;
		this.displayService.startLoading();
		this.commsService.updateInvoiceBillingDates(data).subscribe((res) => {
			console.log('Update Invoice Billing Dates RES: ', res);
			self.supInvoiceDetails['billingstart'] = event.data.billingstart;
			self.supInvoiceDetails['billingend'] = event.data.billingend;
			self.noteService.displaySuccess('The supplier invoice has been updated successfully.');
			self.displayService.endLoading();
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Update Invoice Billing Dates', err);
		});
	}
}
